import { IQ_API_BASE_URL } from "./constants.js";
import { loadPageOnResolve } from "./script.js";

document.addEventListener("DOMContentLoaded", function () {
  const domainTag = document.querySelector("#domain-tags");
  const caseStudiesGrid = document.getElementById("case-studies-grid");

  const filterChipDomain = new Set([]); // Use Set to avoid duplicates

  function truncateWords(text, wordLimit = 20) {
    const words = text.split(" ");
    if (words.length <= wordLimit) return text;
    return words.slice(0, wordLimit).join(" ") + "…";
  }

  function dateConvertion(dateCode) {
    const dateStr = new Date(dateCode);
    const options = { month: "short", day: "numeric", year: "numeric" };
    return dateStr.toLocaleDateString("en-US", options).replace(",", "");
  }

  function filterCaseStudies() {
    const activeTag = document.querySelector("#domain-tags .filter-tag.active");
    const selectedDomain = activeTag ? activeTag.dataset.domain : "all";
    let visibleCount = 0;

    const caseStudies = document.querySelectorAll(".case-study-card");
    caseStudies.forEach((study) => {
      if (study.dataset.ignoreFilter === "true") {
        study.style.display = "flex";
        return;
      }

      const domains = study.dataset.domain
        .split(",")
        .map((d) => d.trim().toLowerCase());

      const matchDomain =
        selectedDomain === "all" || domains.includes(selectedDomain);

      study.style.display = matchDomain ? "flex" : "none";
      if (matchDomain) visibleCount++;
    });

    const noResults = document.querySelector(".no-results");
    if (noResults) noResults.remove();

    if (visibleCount === 0) {
      const div = document.createElement("div");
      div.className = "no-results";
      div.innerHTML = "<h3>No Blog Found</h3><p>Try another domain filter.</p>";
      caseStudiesGrid.appendChild(div);
    }
  }

  async function updateBlogData() {
    const res = await fetch(`${IQ_API_BASE_URL}/iqtechmax/blog`);
    const data = await res.json();
    caseStudiesGrid.innerHTML = "";

    data.forEach((study) => {
      const tags = Array.isArray(study.tags) ? study.tags : [study.tags];
      const domainChips = tags
        .map((tag) => {
          filterChipDomain.add(tag.toUpperCase());
          return `<span class="chip">${tag.toUpperCase()}</span>`;
        })
        .join(" ");

      const domainDataAttr = tags.map((t) => t.toLowerCase()).join(", ");

      caseStudiesGrid.innerHTML += `
          <div class="case-study-card blur_card tilt-card radial-hover-card" data-domain="${domainDataAttr}">
            <div class="radial-hover-effect"></div>
            <div class="domain-indicator">${domainChips}</div>
            <div class="card-content">
              <h3 class="card-title">${study.title}</h3>
              <p class="card-author">${study.author} | ${dateConvertion(
        study.updatedAt
      )}</p>
              <p class="card-description">${truncateWords(study.caption)}</p>
              <a href="${
                study.blogURL
              }" target="_blank" rel="noopener noreferrer">
                <button class="button_know_more">Read More…</button>
              </a>
            </div>
            ${
              study.bannerURL
                ? `<img class="card-image" src="${study.bannerURL}" alt="${study.title}" loading="lazy" />`
                : `<div class='card-image-placeholder blur_card'> ...SVG PLACEHOLDER... </div>`
            }
          </div>`;
    });

    // Create filter chips
    filterChipDomain.forEach((chipValue) => {
      const chip = document.createElement("button");
      chip.classList.add("filter-tag");
      chip.setAttribute("data-domain", chipValue.toLowerCase());
      chip.innerText = chipValue;
      domainTag.appendChild(chip);
    });

    // Attach click listeners
    document.querySelectorAll("#domain-tags .filter-tag").forEach((tag) => {
      tag.addEventListener("click", function () {
        document
          .querySelectorAll("#domain-tags .filter-tag")
          .forEach((t) => t.classList.remove("active"));
        this.classList.add("active");
        filterCaseStudies();
      });
    });

    // Run filter after rendering
    filterCaseStudies();
  }

  loadPageOnResolve(updateBlogData);
});
